module.exports = __webpack_public_path__ + "static/img/r-4-5.f25d7f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-4/r-4-5.png
// module id = NIf1
// module chunks = 0